

require('./styles');

var _angular = require('angular');

var _underscore = require('underscore');

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

define(['squid/index', 'text!./template.html'], function (squid, template) {

    squid.module('xo-mobile-pin.directive', ['squid']).directive('xoMobilePin', function () {
        return {
            scope: {
                pinvalue: '=',
                done: '='
            },
            template: template,
            controller: function controller($scope, $element) {
                $scope.pinvalue = {};
                var delay = 200;
                $scope.doingReset = false;
                $scope.fields = ['field1', 'field2', 'field3', 'field4'];

                function reset() {
                    $scope.fields.forEach(function (fieldName) {
                        $scope.pinvalue[fieldName] = '';
                        var currentElement = document.getElementById(fieldName);
                        angular.element(currentElement)[0].type = 'number';
                    });
                    var ele = document.getElementById($scope.fields[0]);
                    angular.element(ele)[0].focus(); // set focus to first elemnt
                    $scope.doingReset = false;
                }
                reset();

                function getPin() {
                    var result = '';
                    $scope.fields.forEach(function (fieldName) {
                        result = result + String($scope.pinvalue[fieldName]);
                    });
                    return result;
                }

                function isPinValid(val) {
                    return (/^\d{1}/.test(val)
                    );
                }

                function isDone() {
                    var values = _underscore2['default'].values($scope.pinvalue);
                    var result = _underscore2['default'].every(values, function (val) {
                        return isPinValid(val);
                    });
                    return result;
                }

                function moveCursor(currID, direction, clearCurrent) {
                    var currentIndex = $scope.fields.indexOf(currID);
                    var currEle = angular.element(document.getElementById(currID))[0];
                    if (clearCurrent) {
                        currEle.value = '';
                        $scope.pinvalue[currID] = '';
                    }

                    var nextIndex = void 0;
                    if (direction === 'left') {
                        nextIndex = currentIndex > 0 ? currentIndex - 1 : 0;
                    }
                    if (direction === 'right') {
                        nextIndex = currentIndex < $scope.fields.length - 1 ? currentIndex + 1 : $scope.fields.length - 1;
                    }

                    var nextID = $scope.fields[nextIndex];
                    if (nextID !== currID) {
                        var nextEle = angular.element(document.getElementById(nextID))[0];
                        nextEle.type = 'number';
                        nextEle.focus();
                    }
                }

                $scope.$on('resetPin', function () {
                    $scope.doingReset = true;
                    (0, _angular.$timeout)(function () {
                        return reset();
                    }, delay);
                });

                $scope.pressedKey = function (eventObj) {
                    var currID = eventObj && eventObj.currentTarget.id;
                    if (eventObj && eventObj.key === 'Backspace') {
                        moveCursor(currID, 'left', true);
                    }
                };

                $scope.releaseKey = function (eventObj) {
                    var currID = eventObj && eventObj.currentTarget.id;
                    if (eventObj && eventObj.key === 'Backspace') {
                        return;
                    }
                    var currEle = angular.element(document.getElementById(currID))[0];
                    var currentValue = $scope.pinvalue[currID];

                    if (isDone()) {
                        currEle.blur();
                        var pin = getPin();
                        $scope.done(pin);
                    }
                    if (isPinValid(currentValue)) {
                        moveCursor(currID, 'right', false);
                    }
                };

                $scope.onFocus = function (eventObj) {
                    var currID = eventObj && eventObj.currentTarget.id;
                    var currEle = angular.element(document.getElementById(currID))[0];
                    $scope.pinvalue[currID] = '';
                    currEle.value = '';
                    currEle.type = 'number';
                };

                $scope.onBlur = function (eventObj) {
                    var currID = eventObj && eventObj.currentTarget.id;
                    var currentValue = eventObj && eventObj.currentTarget.value;
                    var currEle = angular.element(document.getElementById(currID))[0];

                    if (!$scope.doingReset && currentValue) {
                        (0, _angular.$timeout)(function () {
                            currEle.type = 'password';
                        }, delay);
                    }
                };
            }
        };
    });
});

_angular.$timeout;


//////////////////
// WEBPACK FOOTER
// ./components/xo-ui-components/src/mobile-pin/directive.js
// module id = ./components/xo-ui-components/src/mobile-pin/directive.js
// module chunks = 1